<template>
  <div class="market">
    <div v-if="market"
         :class="['market', 'big3', big3markettype,
         {'suspended': !market.istradable },
         {'two-selections': market.selections.length === 2 },
         {'same-prices': isSamePrice }]"
         :idfomarket="market.idfomarket"
         :isfrompush="(market.V !== undefined).toString()">
      <div class="header" v-if="showheader === undefined || showheader">
        <div class="market-name">
          <h4 v-if="big3markettype === 'TP'" class="market-name-title text-overflow">{{ $t('Market.TOTAL') }}</h4>
          <h4 v-if="big3markettype === 'PS'" class="market-name-title text-overflow">{{ $t('Market.SPREAD') }}</h4>
          <h4 v-if="big3markettype === 'ML'" class="market-name-title text-overflow">{{ $t('Market.MONEY') }}</h4>
        </div>
      </div>

      <div v-if="isDebug" class="debug">
        {{ market.idfomarket }}<br />
        isfrompush {{ (market.V !== undefined).toString() }}
      </div>

      <div class="selections-container">
        <!-- BIG3 -->
        <div v-if="market.selections && isHadMarket" class="selections had">
          <div :class="['selections', { 'hasdraw': market.selections.filter(sel => sel.hadvalue === 'D').length > 0 }, {'handicap': market.name.toLowerCase().indexOf('handicap') > -1}]">
            <div class="selection" v-if="selectionsGroupedByHadType[hadvalue].length" v-for="(hadvalue, index) in ['A', 'H', 'O', 'U']" :key="index" :class="hadvalue">
              <div class="selection-column"
                   v-for="selection in selectionsGroupedByHadType[hadvalue]"
                   :key="selection.idfoselection">

                <selection
                  :selection="selection"
                  :istradable="market.istradable"
                  :showselectionname="false"
                  :ishad="true"></selection>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
           EMPTY
        </div>
      </div>
    </div>
    <div v-else
         class="market big3 two-selections empty"
         idfomarket="null"
         isfrompush="false">
      <div class="header" v-if="showheader === undefined || showheader">
        <div class="market-name">
          <h4 v-if="big3markettype === 'TP'" class="market-name-title text-overflow">{{ $t('Market.TOTAL') }}</h4>
          <h4 v-if="big3markettype === 'PS'" class="market-name-title text-overflow">{{ $t('Market.SPREAD') }}</h4>
          <h4 v-if="big3markettype === 'ML'" class="market-name-title text-overflow">{{ $t('Market.MONEY') }}</h4>
        </div>
      </div>
      <div class="selections-container">
        <div v-if="brand_white1 || brand_translux5" class="selections had">
          <div class="selections">
            <div class="selection">
              <div class="selection-column">
                <div class="selection-component">
                  <div class="value">
                    <div class="selectionprice">

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="selection">
              <div class="selection-column">
                <div class="selection-component">
                  <div class="value">
                    <div class="selectionprice">

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="selectionprice">

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'

  import Screen from '@/components/mixins/Screen'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Brands from '@/components/mixins/Brands'

  import selection from '@/components/bettingoffer/selection'

  export default {
    name: 'big3market',

    components: {
      selection
    },

    mixins: [
      Screen,
      Brands,
      BettingOffer
    ],

    props: [
      'market',
      'showheader',
      'big3markettype'
    ],

    data () {
      return {
        vue: Vue,
        clickTO: null,
        clickModal: null,
        action: null,
        selectionsPrices: {},
        expandedMarkets: {},
        panel: true,
        counter: 0
      }
    },

    computed: {
      isSamePrice () {
        var firstSelPriceUp = this.market.selections && this.market.selections[0] && this.market.selections[0].currentpriceup
        var firstSelPriceDown = this.market.selections && this.market.selections[0] && this.market.selections[0].currentpricedown

        return this.market.selections.filter(sel => sel.currentpriceup === firstSelPriceUp && sel.currentpricedown === firstSelPriceDown).length === this.market.selections.length
      },
      isHadMarket () {
        if (this.market.selections) {
          return this.market.selections.filter(sel => sel.hadvalue === 'H').length > 0 ||
            this.market.selections.filter(sel => sel.hadvalue === 'D').length > 0 ||
            this.market.selections.filter(sel => sel.hadvalue === 'A').length > 0 ||
            this.market.selections.filter(sel => sel.hadvalue === 'U').length > 0
        } else {
          return []
        }
      },
      selectionsGroupedByHadType () {
        var selections = {}

        if (this.market && this.market.selections && this.market.selections.length) {
          ['A', 'H', 'O', 'U'].forEach(hadvalue => {
            selections[hadvalue] = this.market.selections.filter(sel => sel.hadvalue === hadvalue)
          })
        }

        return selections
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
@import '~@/css/config'
@import '~@/css/mixins'

  .markets
  .market
  .markets-wrapper
    height: 100%

  .markets-wrapper
    margin-left: 7px

  .markets
    overflow hidden


    .market
      float left
      display: flex
      flex-direction: column
      margin-right: 2px

      &:last-child
        margin-right: 0

      .header
        text-align center
        flex: 0 0 unit(head-height, px)
        align-center()

      .selections-container
        flex: 1 1 auto
        display: flex

        .browser-internet-explorer.browser-version-11 &
          flex: 1 1 100%

      .selections
        overflow hidden

        .selection
          border-right: solid 1px silver
          width 125px

          &:last-child
            border none

      &.big3
        .selections
          flex-direction: column

          .selections
            height: 100%

        .selection
          float none
          flex: 0 0 50%

          &:first-child
            border-right: none
</style>



// WEBPACK FOOTER //
// src/components/bettingoffer/big3market.vue